import {Field} from "formik";
import React, {useState} from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
    ACTION_BUTTON_TYPES as ABT,
    pushToParams, pushWithRow,
    requestTo, withNewTitle
} from "../../components/action-buttons/ActionButtonGenerator";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import TextInput from "../../components/form-fields/TextInput";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import { useTranslation } from 'react-i18next';       
import { truncateText } from "../../utils";            /* Added Line */


export default function Roles() {
    const [showModal, setShowModal] = useState(false);
    const [refreshList, setRefreshList] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [initialValues, setInitialValues] = useState({});
    const [selectedRow, setSelectedRow] = useState(null);
    const [t, i18n] = useTranslation();         /* Added Line */

    const validationSchema = yup.object({
        name: yup.string().required("Gerekli alan."),
        /* array örnek validasyon: yup.array().min(1,"En az bir eleman seçilmelidir.").required("Gerekli alan."),*/
    });

    const arrangeBeforePersist = (values) => {
        let payload = {
            name: values.name,
            descr: values.descr,
            id: values.id,
            stId: values.stId || 90,
        };
        return payload;
    };

    const adaptDataForUpdate = (data) => {
        let adaptedData = {
            name: data.name,
            descr: data.descr,
            id: data.id,
            stId: data.stId,
        };
        setInitialValues(adaptedData);
    };

    const onUpdateButtonClicked = (selectedRow) => {
        setShowModal(true);
        setIsUpdating(true);
        setSelectedRow(selectedRow);
    };

    const onAddButtonClicked = () => {
        setShowModal(true);
        setIsUpdating(false);
        setInitialValues({});
    };

    return (
        <Main>
            <div className="row">
                <div className="col-xl-12 col-xxl-12">
                    <CrudMain
                        onAddButtonClicked={onAddButtonClicked}
                        showModal={showModal}
                        setShowModal={setShowModal}
                        title={t("sidebar.roller")}
                        hideNewAddButton
                    >
                        <FormikForm
                            isUpdating={isUpdating}
                            entityId={selectedRow && selectedRow.id}
                            entityFetchId="id"
                            endPointUrl="role/create"
                            fetchPointUrl="role/find"
                            editPointUrl="role/update"
                            arrangeBeforePersist={arrangeBeforePersist}
                            adaptDataForUpdate={adaptDataForUpdate}
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            closeModal={() => setShowModal(false)}
                            refreshList={() => setRefreshList(!refreshList)}
                        >
                            <Field
                                name="name"
                                label={t("roles.adi")}
                                colNumber="12"
                                component={TextInput}
                                required
                            />
                            <Field
                                name="descr"
                                label={t("roles.aciklama")}
                                colNumber="12"
                                component={TextInput}
                            />
                        </FormikForm>
                    </CrudMain>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <ListComponent
                        entityName="roller"
                        endpoint="role/list"
                        keyField="id"
                        refreshList={refreshList}
                        columns={[
                            {
                                dataField: "id",
                                text: "ID",
                                sort: true,
                                headerClasses: "id-header"
                            },
                            {
                                dataField: "name",
                                text: `${t("demandList.adi")}`,
                                sort: true,
                            },
                            {
                                dataField: "descr",
                                text: `${t("demandList.aciklama")}`,
                                formatter: (data) => truncateText(data, 50, 40),
                                sort: true,
                            },
                        ]}
                        actionButtonsObject={{
                            actions: [
                                // pushToParams(ABT.EDIT, onUpdateButtonClicked),
                                // pushWithRow(withNewTitle(ABT.GOTOPAGE,"Yetkiler") ,"/rol-yetki"),
                                // requestTo(ABT.DELETE, "role/delete"),
                            ],
                            generator: DefaultActionButtonGenerator,
                        }}
                    />
                </div>
            </div>
        </Main>
    );
}
